import {
  AffiliatesApiAdapter,
  AffiliatesCommissionsPage,
} from '../adapters/AffiliatesApiAdapter';
import { Filters, AffiliatesCommission } from '../models/Affiliates';

export type Page = AffiliatesCommissionsPage;

export class Service {
  constructor(private apiAdapter: AffiliatesApiAdapter) {}

  async getAllMovements(
    filters: Filters = {}
  ): Promise<AffiliatesCommission[]> {
    return this.apiAdapter.getAll();
  }

  async getPaginatedMovements(filters: Filters = {}): Promise<Page> {
    const { searchTerm, limit } = filters;

    // 🧠 Validaciones opcionales
    if (limit && limit > 100) {
      throw new Error('El límite no puede ser mayor a 100');
    }

    if (searchTerm && searchTerm.length < 2) {
      throw new Error(
        'El término de búsqueda debe tener al menos 2 caracteres'
      );
    }

    return this.apiAdapter.getAffiliatesPaginated(filters);
  }

  async getPaginated(filters: Filters = {}): Promise<Page> {
    const { searchTerm, limit } = filters;

    if (limit && limit > 100) {
      throw new Error('El límite no puede ser mayor a 100');
    }

    if (searchTerm && searchTerm.length < 2) {
      throw new Error(
        'El término de búsqueda debe tener al menos 2 caracteres'
      );
    }

    return this.apiAdapter.getAffiliatesPaginated(filters);
  }
}
